(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-video"] && !Shopify.designMode) return;
  try {
    
  class BannerVideoControl extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('[data-banner-video-toggle]');
      this.videos = Array.from(this.querySelectorAll('.banner-video__video'));

      if (!this.button || this.videos.length === 0) return;

      this.onToggleClick = this.toggle.bind(this);
      this.button.addEventListener('click', this.onToggleClick);
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onToggleClick);
    }

    toggle() {
      const isPaused = this.button.getAttribute('data-paused') === 'true';

      this.videos.forEach((video) => {
        if (isPaused) {
          video.play();
        } else {
          video.pause();
        }
      });

      this.button.setAttribute('data-paused', (!isPaused).toString());
    }
  }

  customElements.define('banner-video-control', BannerVideoControl);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-info"] && !Shopify.designMode) return;
  try {
    
  class SeccionAcompanamosCarrusel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.track = this.querySelector('.seccion-acompanamos-carrusel');
      this.section = this.closest('.seccion-acompanamos');
      this.prevButton = this.section ? this.section.querySelector('.seccion-acompanamos-flecha--prev') : null;
      this.nextButton = this.section ? this.section.querySelector('.seccion-acompanamos-flecha--next') : null;

      if (!this.track) return;

      this.onPrevClick = this.scrollByCard.bind(this, -1);
      this.onNextClick = this.scrollByCard.bind(this, 1);
      this.onScroll = this.updateButtonsState.bind(this);

      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);

      this.updateButtonsState();
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick);
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    scrollByCard(direction) {
      const card = this.track.querySelector('.seccion-acompanamos-columna');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || 0);
      const distance = (card.getBoundingClientRect().width + gap) * direction;
      this.track.scrollBy({ left: distance, behavior: 'smooth' });
    }

    updateButtonsState() {
      const maxScrollLeft = this.track.scrollWidth - this.track.clientWidth - 1;

      if (this.prevButton) {
        this.prevButton.disabled = this.track.scrollLeft <= 0;
      }

      if (this.nextButton) {
        this.nextButton.disabled = this.track.scrollLeft >= maxScrollLeft;
      }
    }
  }

  customElements.define('seccion-acompanamos-carrusel', SeccionAcompanamosCarrusel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colecciones-destacadas"] && !Shopify.designMode) return;
  try {
    
  class SeccionPiezasCarrusel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.track = this.querySelector('.seccion-piezas-carrusel');
      this.section = this.closest('.seccion-piezas');
      this.prevButton = this.section ? this.section.querySelector('.seccion-piezas-flecha--prev') : null;
      this.nextButton = this.section ? this.section.querySelector('.seccion-piezas-flecha--next') : null;

      if (!this.track) return;

      this.onPrevClick = this.scrollByCard.bind(this, -1);
      this.onNextClick = this.scrollByCard.bind(this, 1);
      this.onScroll = this.updateButtonsState.bind(this);

      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);

      this.updateButtonsState();
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick);
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    scrollByCard(direction) {
      const card = this.track.querySelector('.seccion-piezas-tarjeta');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || 0);
      const distance = (card.getBoundingClientRect().width + gap) * direction;
      this.track.scrollBy({ left: distance, behavior: 'smooth' });
    }

    updateButtonsState() {
      const maxScrollLeft = this.track.scrollWidth - this.track.clientWidth - 1;

      if (this.prevButton) {
        this.prevButton.disabled = this.track.scrollLeft <= 0;
      }

      if (this.nextButton) {
        this.nextButton.disabled = this.track.scrollLeft >= maxScrollLeft;
      }
    }
  }

  customElements.define('seccion-piezas-carrusel', SeccionPiezasCarrusel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-enmadera"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.pieEnmIniciado) return;
    window.pieEnmIniciado = true;

    document.addEventListener('click', function (evento) {
      var acordeon = evento.target.closest('[data-pie-acordeon]');
      if (acordeon) {
        var raiz = acordeon.closest('.pie-enm');
        if (!raiz || !raiz.classList.contains('pie-enm--acordeon')) return;
        if (window.matchMedia('(min-width: 749px)').matches) return;
        var columna = acordeon.closest('.pie-enm__columna');
        var abierta = columna.classList.toggle('esta-abierta');
        acordeon.setAttribute('aria-expanded', abierta ? 'true' : 'false');
        return;
      }

      var toggle = evento.target.closest('[data-pie-nl-toggle]');
      if (toggle) {
        var interno = toggle.closest('.pie-enm__nl-interno');
        if (!interno) return;
        interno.classList.add('esta-abierto');
        var campo = interno.querySelector('input[type="email"]');
        if (campo) campo.focus();
      }
    });

    document.addEventListener('change', function (evento) {
      if (evento.target.matches('[data-pie-region]') && evento.target.form) {
        evento.target.form.submit();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.mobileMenu = this.querySelector('header-drawer');
      this.currentScrollTop = 0;
      this.preventHide = false;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll(event) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide || (this.mobileMenu && this.mobileMenu.isOpen && window.innerWidth <= 1160)) {
          return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventReveal) {
          return;
        }
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-categorias"] && !Shopify.designMode) return;
  try {
    
  class SeccionCategoriasCarrusel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.track = this.querySelector('.seccion-categorias-carrusel');
      this.section = this.closest('.seccion-categorias');
      this.prevButton = this.section ? this.section.querySelector('.seccion-categorias-flecha--prev') : null;
      this.nextButton = this.section ? this.section.querySelector('.seccion-categorias-flecha--next') : null;

      if (!this.track) return;

      this.onPrevClick = this.scrollByAmount.bind(this, -1);
      this.onNextClick = this.scrollByAmount.bind(this, 1);
      this.onScroll = this.updateButtonsState.bind(this);

      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);

      this.updateButtonsState();
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick);
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    scrollByAmount(direction) {
      const distance = this.track.clientWidth * 0.6 * direction;
      this.track.scrollBy({ left: distance, behavior: 'smooth' });
    }

    updateButtonsState() {
      const maxScrollLeft = this.track.scrollWidth - this.track.clientWidth - 1;

      if (this.prevButton) {
        this.prevButton.disabled = this.track.scrollLeft <= 0;
      }

      if (this.nextButton) {
        this.nextButton.disabled = this.track.scrollLeft >= maxScrollLeft;
      }
    }
  }

  customElements.define('seccion-categorias-carrusel', SeccionCategoriasCarrusel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-galeria-social"] && !Shopify.designMode) return;
  try {
    
  class GaleriaSocialCarrusel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.track = this.querySelector('.seccion-galeria-social-carrusel');
      this.section = this.closest('.seccion-galeria-social');
      this.prevButton = this.section ? this.section.querySelector('.seccion-galeria-social-flecha--prev') : null;
      this.nextButton = this.section ? this.section.querySelector('.seccion-galeria-social-flecha--next') : null;

      if (!this.track) return;

      this.onPrevClick = this.scrollByCard.bind(this, -1);
      this.onNextClick = this.scrollByCard.bind(this, 1);
      this.onScroll = this.updateButtonsState.bind(this);

      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);

      this.updateButtonsState();
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick);
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    scrollByCard(direction) {
      const card = this.track.querySelector('.seccion-galeria-social-item');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || 0);
      const distance = (card.getBoundingClientRect().width + gap) * direction;
      this.track.scrollBy({ left: distance, behavior: 'smooth' });
    }

    updateButtonsState() {
      const maxScrollLeft = this.track.scrollWidth - this.track.clientWidth - 1;

      if (this.prevButton) {
        this.prevButton.disabled = this.track.scrollLeft <= 0;
      }

      if (this.nextButton) {
        this.nextButton.disabled = this.track.scrollLeft >= maxScrollLeft;
      }
    }
  }

  customElements.define('galeria-social-carrusel', GaleriaSocialCarrusel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-info-producto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function closeOnOverlayClick(event) {
      const overlay = event.target.closest('.seccion-info-producto-modal .modal__overlay');
      if (!overlay) return;

      const modal = overlay.closest('.seccion-info-producto-modal');
      if (!modal) return;

      const closeButton = modal.querySelector('.modal-close-button');
      if (closeButton) {
        closeButton.click();
      }
    }

    document.addEventListener('click', closeOnOverlayClick);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-proceso-etapas"] && !Shopify.designMode) return;
  try {
    
  class ProcesoEtapasAcordeon extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-proceso-etapa]'));
      this.onClick = this.handleClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    handleClick(event) {
      const clicked = event.target.closest('[data-proceso-etapa]');
      if (!clicked) return;

      this.items.forEach((item) => {
        const isActive = item === clicked;
        item.classList.toggle('seccion-proceso-etapas-item--activo', isActive);
        item.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });
    }
  }

  customElements.define('proceso-etapas-acordeon', ProcesoEtapasAcordeon);

  } catch(e) { console.error(e); }
})();
})();
